import './homepage.css';
import './viewAllStakeholders.css';
import React, { useState, useEffect, useRef } from "react";

import { GET_STAKEHOLDERS_BY_CRITERIA, GET_ALL_STAKEHOLDERS, GET_USER_DETAILS } from '../../common/URLs';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { Box, CardContent, Card, Tab, Typography, Button, IconButton, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab } from '@mui/material';
import { PROD, FILE_NAME_VALIDATION_ERROR } from "../../common/constants";
import Link from "@mui/material/Link";
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { loaderService } from '../../common/custom-loader/loader-service';
import { rescgetStakeholderType } from '../../resource/screens/resourceUpdation/resourceUpdateApi';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Download as DownloadIcon } from '@mui/icons-material';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import { GROWER_BULK_UPDATE } from '../../common/URLs';
import { fileNameValidation } from '../../common/commonValidations';
import { useTranslation } from 'react-i18next';
import { EditIcon, SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

function ViewAllActiveApplications() {
    const { t } = useTranslation();
    const [stakeHolders, setStakeHolders] = useState();
    const [emailId, setEmailId] = useState();
    const [userDetails, setUserDetails] = useState();
    const location = useLocation();
    const userId = location?.state?.userId;
    const [stakeUrn, setStakeUrn] = useState();
    let status = location?.state?.status;
    const [tabValue, setTabValue] = React.useState('1');
    const [selectedFile, setSelectedFile] = useState();
    const [uploadDetails, setUploadDetails] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
    const extensionList = ['xls', 'xlsx', 'xlsm'];
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const [isApiCalled, setIsApiCalled] = useState(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);

    useEffect(() => {
        if (uploadDetails) {
            if (uploadDetails?.data?.isSuccess === true) {
                toast.success(uploadDetails?.data?.message);
                getAllStakeholders("All");
                // navigate('../viewAllActiveApplications')
            }
            else if (uploadDetails?.data?.isSuccess === false) {
                toast.error(uploadDetails?.data?.message);
            }
            else {
                toast.error(uploadDetails?.data + ": Add relevant file");
            }
        }
    }, [uploadDetails]);

    const handleChange = (e) => {
        setFileuploadError('');
        setSelectedFile(e.target.files[0])
    };

    // const onConfirmSubmit = () => {
    //     handleLogModalCloseSubmit();
    //     getexcelUploadDetails();
    // }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await getexcelUploadDetails();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenSubmit(false);
            setIsApiCalled(false);
        }
    };


    const onSubmit = (e) => {
        if (selectedFile) {
            const extension = selectedFile.name.split('.').pop().toLowerCase();
            const isXlsFile = !!extension && extensionList.includes(extension);
            if (!isXlsFile) {
                setFileuploadError("Only .xls, .xlsx, .xlsm files are allowed.");
                return;
            }
            else if (selectedFile.name.split('.').length > 2) {
                setFileuploadError("Double extension file detected.");
                return;
            }
            else if (selectedFile.size >= 5000000) {
                setFileuploadError("The file size should be less than 5MB.");
                return;
            }
            else if (fileNameValidation(selectedFile.name)) {
                setFileuploadError(FILE_NAME_VALIDATION_ERROR);
                return;
            }
            else {
                handleLogModalOpenSubmit();
                e.preventDefault();
            }
        }
    };
    function getexcelUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        apiClient
            .post(GROWER_BULK_UPDATE, formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                setUploadDetails(response)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                setUploadDetails(error?.response)
                loaderService.hideLoader();
            });
    }
    const [details, setDetails] = useState({
        "urn": ""
    });

    const [errorMessage, setErrorMessage] = useState({
        urnError: "",

    })
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const [getCategoryType, setGetCategoryType] = useState(' ');

    const userlog = useRef(true);
    useEffect(() => {
        userlog.current = false;
        // console.log("getCategoryType", getCategoryType?.stakeHolder?.categoryName)
        if (getCategoryType.stakeHolder) {
            if (getCategoryType?.stakeHolder?.categoryName == "Transporter") {
                navigate("/sidebar/viewAllActiveApplications/registrationDetailsTransporter", { state: { URN: stakeUrn } })
            }
            else if (getCategoryType?.stakeHolder?.categoryName == "HIT") {
                navigate("/sidebar/viewAllActiveApplications/registrationDetailsHit", { state: { URN: stakeUrn } })
            }
            else if (getCategoryType?.stakeHolder?.categoryName == "LLE") {
                navigate("/sidebar/viewAllActiveApplications/registrationDetailsLle", { state: { URN: stakeUrn } })
            }
            else if (getCategoryType?.stakeHolder?.categoryName == "Grower" || getCategoryType?.stakeHolder?.categoryName == "Individual" || getCategoryType.stakeHolder.categoryName == "JFMC" || getCategoryType.stakeHolder.categoryName === "Other Agency") {
                if (getCategoryType.stakeHolder.growerMasters[0].growerType === "Co-operative" || getCategoryType?.stakeHolder?.growerMasters[0].growerType === "FPO" || getCategoryType.stakeHolder.growerMasters[0].growerType === "SHG" || getCategoryType.stakeHolder.growerMasters[0].growerType === "FPC") {
                    navigate("/sidebar/viewAllActiveApplications/registrationMemberDetails", { state: { URN: stakeUrn, stakeHolderSubCategory: getCategoryType.stakeHolder.growerMasters[0].growerType } })
                }
                else if (getCategoryType.stakeHolder.growerMasters[0].growerType === "Forest") {
                    navigate("/sidebar/viewAllActiveApplications/registrationDetailsForest", { state: { URN: stakeUrn } })
                }
                else {
                    navigate("/sidebar/viewAllActiveApplications/registrationDetails", { state: { URN: stakeUrn } });
                }
            }
            else if (getCategoryType.stakeHolder.categoryName == "HIT") {
                navigate("/sidebar/viewAllActiveApplications/hitRegistration", { state: { URN: stakeUrn } });
            }
            else if (getCategoryType.stakeHolder.categoryName == "LLE") {
                navigate("/sidebar/viewAllActiveApplications/lleMainPage", { state: { URN: stakeUrn } })
            }
            else if (getCategoryType.stakeHolder.categoryName == "Interim Storage Operator") {
                navigate("/sidebar/viewAllActiveApplications/registrationDetailsTempStorage", { state: { isPreReg: false, URN: stakeUrn } })
            }
        }
        else {
            if (getCategoryType.message) {
                //   handleLogModalOpen();
                setGetCategoryType(' ')
            }
        }
    }, [userlog, getCategoryType, details]);

    const onEdit = (e, urn) => {
        e.preventDefault();
        setStakeUrn(urn);
        rescgetStakeholderType(urn, setGetCategoryType)

    }

    useEffect(() => {
        getAllStakeholders();
    }, [userDetails]);

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
        }
    }, [getLocalStorageItem('id_token')]);
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const email = decoded.emails?.[0];
            setEmailId(email);

        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        // if (emailId) {
        getUserDetails();
        // }
    }, [emailId]);

    function getUserDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": emailId,
                    // "userRole": localStorage.getItem('role'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.user);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
            });
    }

    function getAllStakeholders(status) {
        if (status == "All") {
            status = "active_applications";
        }
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDERS_BY_CRITERIA,
                {
                    "status": status ? status : "",
                    "createdBy": userId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeHolders(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                loaderService.hideLoader()
                console.log("Error", error)
            });
    }

    const stakeHoldersArray = stakeHolders?.stakeHolders;

    const navigate = useNavigate();

    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
        },
        {
            field: 'name', headerName: t('preReg.name'), width: 180,
            renderCell: params => (params.row.subCategory && params.row.subCategory.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name)
        },
        { field: 'urn', headerName: 'URN', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
        { field: 'categoryName', headerName: 'Stakeholder Type', width: 180 },
        { field: 'subCategory', headerName: 'Stakeholder Subcategory', width: 180 },
        { field: 'registrationStatus', headerName: 'Status', width: 150 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 180 },
        {
            field: 'edit',
            headerName: 'Actions',
            type: 'action',
            width: 100,
            renderCell: (params) => {
                return (
                    <Tooltip title="Edit">
                        <IconButton color='primary' onClick={(e) => onEdit(e, params.row.urn)}>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>

                )
            }
        },
    ];

    return (
        <>
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG68</p>}
            <Card>
                <CardContent>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Bulk Update" value="1" />
                                <Tab label="Registration" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                            <Card>
                                <CardContent>
                                    <a style={{ display: "flex", flexDirection: "row" }} href='https://abrplscmsandbox.blob.core.windows.net/stakeholdertemplate/StakeHolderUpdateTemplate.xlsm'>
                                        <DownloadIcon /> <Typography variant="subtitle1">Download Registration Update Template.</Typography></a>
                                    <Typography variant="subtitle2" mt={2}>Upload registration update file</Typography>
                                    <Box mt={1}>
                                        <label className="ChooseFileInputAdminPincode">
                                            <input style={{ fontSize: '2vh' }} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => handleChange(e)} name="Bulk_upload" />
                                        </label>
                                        <Typography variant="subtitle2" fontSize="1.8vh" color="green">(upload only .xls, .xlsx, .xlsm files.File size limit=5MB)</Typography>
                                        <Typography variant="subtitle2" fontSize="1.8vh" color="red">{fileuploadError}</Typography>
                                    </Box>
                                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1}>
                                        <Button startIcon={<SubmitIcon/>} sx={{ minWidth: 100 }} variant="contained" name="excel_upload" onClick={(e) => onSubmit(e)}>Submit</Button>
                                    </Box>
                                </CardContent>
                            </Card>
                            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
                        </TabPanel>
                        <TabPanel value="2" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                            <div style={{ display: "inline-flex" }}>
                                {/* <Typography variant="h4" sx={{ mb: 2 }}>
                            <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                                <KeyboardArrowLeftRounded />
                            </Fab>
                        </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                {/*              <div className="hitDetailsText">Registration</div>*/}
                            </div>
                            {stakeHoldersArray &&
                                <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                    <DataGrid
                                        rows={stakeHoldersArray}
                                        columns={columns}
                                        pageSize={10}
                                        getRowId={(row) => row?.id}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                    />
                                </Box>}
                        </TabPanel>

                    </TabContext>
                </CardContent>
            </Card>
        </>

    );
}
export default ViewAllActiveApplications;

